module.exports = __webpack_public_path__ + "img/light-preloader.d006248.gif";